import React, { useState } from "react";
import { BsDisplay } from "react-icons/bs";
import { FiLogOut } from "react-icons/fi";

function ManagerUserProfileReportsPreferences() {
  const optionsSetReports = [
    {
      title: "Hiring Trends",
    },
    {
      title: "Recruiter  Performance",
    },
    {
      title: "Diversity Metrics",
    },
  ];
  const optionsRecruitment = [
    {
      title: "Time to Hire",
    },
    {
      title: "Time to Fill",
    },
    {
      title: "Offer acceptance rate",
    },
    {
      title: "Candidate Drop-Off Rate",
    },
  ];
  const optionsRecruiter = [
    {
      title: "Sourcing Effectiveness",
    },
    {
      title: "Recruiter Performance ",
    },
  ];
  const [notificationSettings, setNotificationSettings] = useState({
    HiringTrends: false,
    RecruiterPerformanceSetReport: false,
    DiversityMetrics: false,
    TimeToHire: false,
    TimeToFill: false,
    OfferAcceptanceRate: false,
    CandidateDropOffRate: false,
    SourcingEffectiveness: false,
    RecruiterPerformance: false,
  });

  return (
    <section className="flex flex-col gap-10">
      {/* set reports */}
      <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8">
        <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
          <div className="flex justify-start items-center flex-row gap-0.5">
            <span className="text-[#414651] text-sm  font-semibold">
              Set Report Preferences
            </span>
          </div>
          <p className="self-stretch text-[#535862] text-sm ">
            Choose the type of report you want to get
          </p>
        </div>
        <div className="min-w-[320px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
          <div className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
            <form action="" className="w-full flex items-start gap-5 flex-col">
              <div className=" w-full ">
                <div className="flex flex-col items-start gap-6 w-full">
                  {optionsSetReports.map((option) => {
                    const key = option.title.replace(/\s+/g, "");
                    return (
                      <div
                        key={key}
                        className="flex items-center w-full border border-b-gray-200 pb-5 last:border-b-0 last:pb-0"
                      >
                        <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                          {option.title}
                        </h2>
                        <div className="flex items-center gap-3">
                          <div
                            onClick={() =>
                              setNotificationSettings((prev) => ({
                                ...prev,
                                [key]: !prev[key],
                              }))
                            }
                            className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                              notificationSettings[key]
                                ? "bg-[#19BFB7]"
                                : "bg-gray-100"
                            } px-[3px] cursor-pointer`}
                          >
                            <span
                              className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                notificationSettings[key]
                                  ? "translate-x-5"
                                  : "translate-x-0"
                              } shadow-sm absolute -translate-y-1/2 top-1/2`}
                            ></span>
                          </div>
                          <p className="text-gray-800 text-sm font-semibold">
                            {notificationSettings[key] ? "YES" : "NO"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </form>
          </div>
          <div className="flex self-stretch justify-start items-center flex-col gap-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex items-center justify-end w-full gap-3 px-6">
              <button className="bg-[#009C97] text-white rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                Save changes
              </button>
              <button className=" text-gray-700 border border-gray-300 hover:bg-gray-100 transition duration-150 rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                Cancle
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="self-stretch bg-[#E9EAEB] h-px"></div>

      {/* Recruitment Performance Metrics */}
      <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8">
        <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
          <div className="flex justify-start items-center flex-row gap-0.5">
            <span className="text-[#414651] text-sm  font-semibold">
              Recruitment Performance Metrics
            </span>
          </div>
          <p className="self-stretch text-[#535862] text-sm ">
            Choose which metrics you want to include in the reports
          </p>
        </div>
        <div className="min-w-[320px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
          <div className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
            <form action="" className="w-full flex items-start gap-5 flex-col">
              <div className=" w-full ">
                <div className="flex flex-col items-start gap-6 w-full">
                  {optionsRecruitment.map((option) => {
                    const key = option.title.replace(/\s+/g, "");
                    return (
                      <div
                        key={key}
                        className="flex items-center w-full border border-b-gray-200 pb-5 last:border-b-0 last:pb-0"
                      >
                        <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                          {option.title}
                        </h2>
                        <div className="flex items-center gap-3">
                          <div
                            onClick={() =>
                              setNotificationSettings((prev) => ({
                                ...prev,
                                [key]: !prev[key],
                              }))
                            }
                            className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                              notificationSettings[key]
                                ? "bg-[#19BFB7]"
                                : "bg-gray-100"
                            } px-[3px] cursor-pointer`}
                          >
                            <span
                              className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                notificationSettings[key]
                                  ? "translate-x-5"
                                  : "translate-x-0"
                              } shadow-sm absolute -translate-y-1/2 top-1/2`}
                            ></span>
                          </div>
                          <p className="text-gray-800 text-sm font-semibold">
                            {notificationSettings[key] ? "YES" : "NO"}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </form>
          </div>
          <div className="flex self-stretch justify-start items-center flex-col gap-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex items-center justify-end w-full gap-3 px-6">
              <button className="bg-[#009C97] text-white rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                Save changes
              </button>
              <button className=" text-gray-700 border border-gray-300 hover:bg-gray-100 transition duration-150 rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                Cancle
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="self-stretch bg-[#E9EAEB] h-px"></div>

      {/* Recruiter & Team Efficiency */}

      <div className="flex flex-wrap self-stretch justify-start items-start flex-row gap-y-4 gap-x-8">
        <div className="min-w-[200px] max-w-[280px] flex flex-1 justify-start items-start flex-col">
          <div className="flex justify-start items-center flex-row gap-0.5">
            <span className="text-[#414651] text-sm  font-semibold">
              Recruiter & Team Efficiency
            </span>
          </div>
          <p className="self-stretch text-[#535862] text-sm ">
            Choose which metrics you want to include in the reports
          </p>
        </div>
        <div className="min-w-[320px] max-w-[720px] flex flex-1 justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
          <div className="flex self-stretch justify-start items-start flex-col gap-6 p-[24px]">
            <form action="" className="w-full flex items-start gap-5 flex-col">
              <div className=" w-full ">
                <div className="flex flex-col items-start gap-6 w-full">
                  {optionsRecruiter.map((option) => {
                    const key = option.title.replace(/\s+/g, "");
                    return (
                      <div
                        key={key}
                        className="flex items-center w-full border border-b-gray-200 pb-5 last:border-b-0 last:pb-0"
                      >
                        <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                          {option.title}
                        </h2>
                        <div className="flex items-center gap-3">
                          <div
                            onClick={() =>
                              setNotificationSettings((prev) => ({
                                ...prev,
                                [key]: !prev[key],
                              }))
                            }
                            className={`w-10 h-5 rounded-full shadow-sm relative transition-colors duration-300 ease-in-out ${
                              notificationSettings[key]
                                ? "bg-[#19BFB7]"
                                : "bg-gray-100"
                            } px-[3px] cursor-pointer`}
                          >
                            <span
                              className={`rounded-full w-3 h-3 transition-transform duration-200 bg-white ${
                                notificationSettings[key]
                                  ? "translate-x-5"
                                  : "translate-x-0"
                              } shadow-sm absolute -translate-y-1/2 top-1/2`}
                            ></span>
                          </div>
                          <p className="text-gray-800 text-sm font-semibold">
                            {notificationSettings[key] ? "YES" : "NO"}
                          </p>
                        </div>
                      </div>
                    );
                  })}

                  <div className="flex items-start w-full border border-b-gray-200 pb-5">
                    <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                      Frequency
                    </h2>

                    <select
                      name=""
                      id=""
                      className="text-gray-400 text-[14px] font-normal w-1/2 border border-gray-200 rounded-lg p-2 outline-none"
                    >
                      <option value="daily">Daily</option>
                    </select>
                  </div>

                  <div className="flex items-start w-full ">
                    <h2 className="text-gray-800 text-sm font-semibold w-1/2">
                      Filters
                    </h2>

                    <textarea
                      name=""
                      id=""
                      className="resize-none  border border-gray-200 rounded-lg w-1/2 outline-0 text-gray-800 p-2 h-22 text-sm"
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="flex self-stretch justify-start items-center flex-col gap-4 pb-4 border-t border-gray-200 pt-4">
            <div className="flex items-center justify-end w-full gap-3 px-6">
              <button className="bg-[#009C97] text-white rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                Save changes
              </button>
              <button className=" text-gray-700 border border-gray-300 hover:bg-gray-100 transition duration-150 rounded-lg px-3 py-1.5 cursor-pointer font-semibold text-sm">
                Cancle
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ManagerUserProfileReportsPreferences;
